var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.0252H21.825V20.5252H14V22.0252ZM14 18.7752H26V17.2752H14V18.7752ZM14 15.5252H26V14.0252H14V15.5252ZM9.64673 30.3535V11.6274C9.64673 11.0817 9.84136 10.6129 10.2306 10.2208C10.6199 9.82882 11.0854 9.63281 11.6272 9.63281H28.3728C28.9185 9.63281 29.3873 9.82882 29.7794 10.2208C30.1714 10.6129 30.3674 11.0817 30.3674 11.6274V24.373C30.3674 24.9148 30.1714 25.3803 29.7794 25.7696C29.3873 26.1589 28.9185 26.3535 28.3728 26.3535H13.6467L9.64673 30.3535ZM12.9967 24.373H28.3728V11.6274H11.6272V25.8926L12.9967 24.373Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.63ca42d8fe76a396f57fc99fd7e31a8b.svg";
export { ForwardRef as ReactComponent };